export default "__VITE_ASSET__BarWaPvP__"